import { Vue, Component } from 'vue-property-decorator'
import GrossingTouchHeader from '@/modules/grossingModule/grossing-touch-view/components/grossing-touch-header/grossing-touch-header.vue'
import GrossingTouchSampleNavigationCard from '@/modules/grossingModule/grossing-touch-view/components/grossing-touch-sample-navigation-card/grossing-touch-sample-navigation-card.vue'
import GrossingTouchSampleViewHeader from '@/modules/grossingModule/grossing-touch-view/views/grossing-touch-sample-view/grossing-touch-sample-view-header/grossing-touch-sample-view-header.vue'
import GrossingTouchSampleTabMacroscopy from '@/modules/grossingModule/grossing-touch-view/views/grossing-touch-sample-view/grossing-touch-sample-tab-macroscopy/grossing-touch-sample-tab-macroscopy.vue'
import GrossingTouchSampleTabPortions from '@/modules/grossingModule/grossing-touch-view/views/grossing-touch-sample-view/grossing-touch-sample-tab-portions/grossing-touch-sample-tab-portions.vue'
import GrossingTouchSampleTabMedia from '@/modules/grossingModule/grossing-touch-view/views/grossing-touch-sample-view/grossing-touch-sample-tab-media/grossing-touch-sample-tab-media.vue'
import GrossingTouchSampleTabData from '@/modules/grossingModule/grossing-touch-view/views/grossing-touch-sample-view/grossing-touch-sample-tab-data/grossing-touch-sample-tab-data.vue'
import GrossingTouchCaseSidepanel from '@/modules/grossingModule/grossing-touch-view/sidepanels/grossing-touch-case-sidepanel/grossing-touch-case-sidepanel.vue'
import GrossingTouchPatientSidepanel from '@/modules/grossingModule/grossing-touch-view/sidepanels/grossing-touch-patient-sidepanel/grossing-touch-patient-sidepanel.vue'
import GrossingTouchRequestSidepanel from '@/modules/grossingModule/grossing-touch-view/sidepanels/grossing-touch-request-sidepanel/grossing-touch-request-sidepanel.vue'
import GrossingTouchSidebar from '@/modules/grossingModule/grossing-touch-view/components/grossing-touch-sidebar/grossing-touch-sidebar.vue'
import GrossingTouchAttachmentsSidepanel from '@/modules/grossingModule/grossing-touch-view/sidepanels/grossing-touch-attachments-sidepanel/grossing-touch-attachments-sidepanel.vue'
import GrossingTouchIncidentsSidepanel from '@/modules/grossingModule/grossing-touch-view/sidepanels/grossing-touch-incidents-sidepanel/grossing-touch-incidents-sidepanel.vue'
import GrossingTouchPeopleSidepanel from '@/modules/grossingModule/grossing-touch-view/sidepanels/grossing-touch-people-sidepanel/grossing-touch-people-sidepanel.vue'

@Component({
    components: {
        GrossingTouchHeader,
        GrossingTouchSampleNavigationCard,
        GrossingTouchSampleViewHeader,
        GrossingTouchSampleTabMacroscopy,
        GrossingTouchSampleTabPortions,
        GrossingTouchSampleTabMedia,
        GrossingTouchSampleTabData,
        GrossingTouchCaseSidepanel,
        GrossingTouchPatientSidepanel,
        GrossingTouchRequestSidepanel,
        GrossingTouchSidebar,
        GrossingTouchAttachmentsSidepanel,
        GrossingTouchIncidentsSidepanel,
        GrossingTouchPeopleSidepanel
    }
})
export default class GrossingTouchSampleView extends Vue {
    private grossingSamples !: Array<object>

    constructor() {
        super()
        this.grossingSamples = [
            {
                location: 'Piel abdominal',
                sampleType: 'Biopsia incisional',
                label: 'A',
                incidentsCount: 1,
                attachmentsCount: 1,
                depleted: false,
                process: true,
                differentFixer: true,
                specialPreserved: false,
                status: {
                    code: 'REGISTERED',
                    name: 'Registrado'
                },
                active: true
            },
            {
                location: 'Piel abdominal',
                sampleType: 'Biopsia incisional',
                registryDate: '11/03/2022 14:16',
                label: 'B',
                incidentsCount: 1,
                attachmentsCount: 0,
                depleted: true,
                process: false,
                differentFixer: true,
                specialPreserved: true,
                status: {
                    code: 'REGISTERED',
                    name: 'Registrado'
                },
                active: false
            },
            {
                location: 'Piel abdominal',
                sampleType: 'Biopsia incisional',
                registryDate: '11/03/2022 14:16',
                label: 'C',
                incidentsCount: 1,
                attachmentsCount: 1,
                depleted: false,
                process: false,
                differentFixer: false,
                specialPreserved: false,
                status: {
                    code: 'REGISTERED',
                    name: 'Registrado'
                },
                active: false
            },
            {
                location: 'Piel abdominal',
                sampleType: 'Biopsia incisional',
                registryDate: '11/03/2022 14:16',
                label: 'D',
                incidentsCount: 1,
                attachmentsCount: 1,
                depleted: false,
                process: false,
                differentFixer: false,
                specialPreserved: false,
                status: {
                    code: 'REGISTERED',
                    name: 'Registrado'
                },
                active: false
            },
            {
                location: 'Piel abdominal',
                sampleType: 'Biopsia incisional',
                registryDate: '11/03/2022 14:16',
                label: 'E',
                incidentsCount: 1,
                attachmentsCount: 1,
                depleted: false,
                process: false,
                differentFixer: false,
                specialPreserved: false,
                status: {
                    code: 'REGISTERED',
                    name: 'Registrado'
                },
                active: false
            },
            {
                location: 'Piel abdominal',
                sampleType: 'Biopsia incisional',
                registryDate: '11/03/2022 14:16',
                label: 'F',
                incidentsCount: 1,
                attachmentsCount: 1,
                depleted: false,
                process: false,
                differentFixer: false,
                specialPreserved: false,
                status: {
                    code: 'REGISTERED',
                    name: 'Registrado'
                },
                active: false
            },
            {
                location: 'Piel abdominal',
                sampleType: 'Biopsia incisional',
                registryDate: '11/03/2022 14:16',
                label: 'G',
                incidentsCount: 1,
                attachmentsCount: 1,
                depleted: false,
                process: false,
                differentFixer: false,
                specialPreserved: false,
                status: {
                    code: 'REGISTERED',
                    name: 'Registrado'
                },
                active: false
            },
            {
                location: 'Piel abdominal',
                sampleType: 'Biopsia incisional',
                registryDate: '11/03/2022 14:16',
                label: 'H',
                incidentsCount: 1,
                attachmentsCount: 1,
                depleted: false,
                process: false,
                differentFixer: false,
                specialPreserved: false,
                status: {
                    code: 'REGISTERED',
                    name: 'Registrado'
                },
                active: false
            }
        ]
    }
}
